'use strict';

angular.module('AcaApp').controller('EmployerController', [
  '$scope',
  '$rootScope',
  'EmployerService',
  '$mdDialog',
  '$location',
  '$route',
  'ShortcutsService',
  'currentEmployer',
  'LayoutService',
  'MsgBetweenCtrlService',
  'UtilsService',
  /* eslint-disable max-len */
  function($scope, $rootScope, EmployerService, $mdDialog, $location, $route, ShortcutsService, currentEmployer, LayoutService, MsgBetweenCtrlService, UtilsService){
    ShortcutsService.disableBackSpaceDefault();
/* eslint-enable max-len */
    $scope.form = {};
    $scope.tinRequired = false;
    $scope.einRequired = false;
    $scope.nameRequired = false;
    $scope.addressRequired = false;
    $scope.cityRequired = false;
    $scope.stateRequired = false;
    $scope.zipRequired = false;
    $scope.einOnlyNumber = false;
    $scope.formChanged = false;
    $scope.validationFlag = false;

    var init = function(){
      if(currentEmployer !== undefined){
        $scope.form = currentEmployer;
        if(currentEmployer.warnings !== undefined && currentEmployer.warnings !== ''){
          $scope.validationMessage = UtilsService.errorMessageValidationForString(currentEmployer.warnings);
          $scope.validationsBE = true;
        }
      }
      else{
        $scope.form = {};
      }
    };

    var _formChanged = function(newValue, oldValue){
      if(newValue !== oldValue){
        $scope.formChanged = true;
      }
    };

    $scope.$watch('form', _formChanged, true);

    $scope.checkNumber = function(event){
      return UtilsService.checkCharacter(event);
    };
    $scope.validateFields = function(field, event){
      $scope.tinRequired = (field === 'editTin' || !field);
      if(field === 'editEin' || !field){
        $scope.einRequired = true;
        if(event !== undefined){
          $scope.einOnlyNumber = (UtilsService.checkCharacter(event) === undefined) ? false : true;
        }
      }
      $scope.nameRequired = (field === 'editName' || !field);
      $scope.addressRequired = (field === 'editAddress' || !field);
      $scope.cityRequired = (field === 'editCity' || !field);
      if(field === 'editState' || !field){
        $scope.stateRequired = !$scope.form.foreigncorpind;
      }
      if(field === 'editZip' || !field){
        $scope.zipRequired = !$scope.form.foreigncorpind;
      }
      $scope.errorMessage = '';
    };
    $scope.closeModal = function(){
      if(MsgBetweenCtrlService.data.parent === undefined){
        ShortcutsService.enableBackSpaceDefault();
        $mdDialog.hide();
      }
      else{
        $mdDialog.show({
          scope: $scope.$new(),
          controller: 'Form1094CController',
          templateUrl: 'app/views/form/modals/form1094C.html',
          preserveScope: true,
          locals: {
            currentEmployer: undefined
          }
        });
      }
    };
    $scope.addEmployer = function(form, action){
      var rpcEmployer = {};

      rpcEmployer = $scope.form;
      rpcEmployer.ptin = angular.uppercase($scope.form.ptin);
      rpcEmployer.payertype = null;
      rpcEmployer.ptintype = $scope.form.ptintype;
      rpcEmployer.pshortname = $scope.form.pshortname;
      rpcEmployer.pein = $scope.form.pein;
      rpcEmployer.pname = $scope.form.pname;
      rpcEmployer.pname2 = $scope.form.pname2;
      rpcEmployer.paddress = $scope.form.paddress;
      rpcEmployer.paddress2 = $scope.form.paddress2;
      rpcEmployer.pcity = $scope.form.pcity;
      rpcEmployer.pstate = $scope.form.pstate;
      rpcEmployer.pzip = $scope.form.pzip;
      rpcEmployer.rescountrycode = $scope.form.rescountrycode;
      rpcEmployer.pforeignprovince = $scope.form.pforeignprovince;
      rpcEmployer.phone = $scope.form.phone;
      rpcEmployer.pfax = $scope.form.pfax;
      rpcEmployer.foreigncorpind = $scope.form.foreigncorpind;
      if(form.$valid){
        if(UtilsService.isNumber($scope.form.pein) !== null){
          switch(action){
            case 'add':
              saveEmployer(rpcEmployer);
              break;
            case 'edit':
              updateEmployer(rpcEmployer);
              break;
            case 'addAnother':
              addAnotherEmployer(rpcEmployer, action);
              break;
          }
        }
        else{
          $scope.errorMessage = 'Employer EIN must only include numbers.';
        }
      }
      else{
        $scope.validateFields();
      }
    };

    var saveEmployer = function(rpcEmployer){
      EmployerService.addEmployer(rpcEmployer, $scope.validationFlag).then(
        function(data){
          if(MsgBetweenCtrlService.data.parent === undefined){
            if(data.result.DataBool){
              $scope.validationFlag = false;
              setCleanEmployer(data.result.UpdatedFields);
              if($scope.employerAction === 'add'){
                openModalConfirmation({
                  titleUI: 'Creation',
                  descriptionUI: 'created',
                  template: 'createConfirmation',
                  home: false
                });
              }
              else{
                openModalConfirmation({
                  template: 'createConfirmationHome',
                  home: true
                });
              }
            }
            else{
              enabledError(data.result);
            }
          }
          else{
            MsgBetweenCtrlService.data.parent.selectedEmployer = rpcEmployer.ptin;
            $mdDialog.show({
              scope: $scope.$new(),
              controller: 'Form1094CController',
              templateUrl: 'app/views/form/modals/form1094C.html',
              preserveScope: true,
              locals:{
                currentEmployer: undefined
              }
            });
          }
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
        }
      );
    };

    var enabledError = function(error){
      $scope.validationFlag = true;
      $scope.validationMessage = UtilsService.errorMessageValidationForString(error.ErrorMessage);
      $scope.validationsBE = true;
    };

    var updateEmployer = function(rpcEmployer){
      rpcEmployer.seghash = currentEmployer.seghash;
      rpcEmployer.datemodified = currentEmployer.datemodified;
      rpcEmployer.modid = currentEmployer.modid;
      rpcEmployer.ptin = currentEmployer.ptin;
      rpcEmployer.modlevel = currentEmployer.modlevel;
      rpcEmployer.datemodified = currentEmployer.datemodified;
      rpcEmployer.recordversion = currentEmployer.recordversion;
      EmployerService.UpdateEmployer(rpcEmployer, $scope.validationFlag).then(
        function(data){
          if(data.result.DataBool){
            setCleanEmployer(data.result.UpdatedFields);
            $scope.validationFlag = false;
            openModalConfirmation({titleUI: 'Update', descriptionUI: 'updated', template: 'createConfirmation', home: false});
          }
          else{
            enabledError(data.result);
          }
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
        }
      );
    };

    var setCleanEmployer = function(nameClean){
      $scope.form.pname = nameClean.substring(nameClean.indexOf(',pname=') + 7, nameClean.indexOf(',pname2='));
      $scope.form.pname2 = nameClean.substring(nameClean.indexOf(',pname2=') + 8, nameClean.indexOf(',pname3='));
    };

    init();

    $scope.evaluate = function(value1, value2){
      return LayoutService.selectedItemToUpperCase(value1, value2);
    };
    var reloadEmployer = function(){
      var path = (currentEmployer || {}).path;

      if(path){
        return;
      }
      $location.path('records').search({section: 'recordEmployer'});
      $route.reload();
    };
    var addAnotherEmployer = function(rpcEmployer, action){
      EmployerService.addEmployer(rpcEmployer, $scope.validationFlag).then(
        function(data){
          if(data.result.DataBool){
            $scope.validationFlag = false;
            $scope.employerAction = action;
            $scope.ptin = rpcEmployer.ptin;
            resetValidateFields();
          }
          else{
            enabledError(data.result);
          }
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
        }
      );
    };

    var resetValidateFields = function(){
      $scope.form = {};
      $scope.tinRequired = false;
      $scope.einRequired = false;
      $scope.nameRequired = false;
      $scope.addressRequired = false;
      $scope.cityRequired = false;
      $scope.stateRequired = false;
      $scope.zipRequired = false;
      $scope.errorMessage = '';
      $scope.validationsBE = false;
      $('#idForm')[0].reset();
      for(var obj in $scope.employerForm){
        if($scope.employerForm[obj] !== undefined && $scope.employerForm[obj].$touched !== undefined){
          $scope.employerForm[obj].$touched = false;
        }
      }
    };

    var openModalConfirmation = function(parameters){
      $mdDialog.hide();
      $mdDialog.show({
        locals: {
          form: $scope.form
        },
        controller: [
          '$scope',
          'form',
          '$mdDialog',
          function($scope, form, $mdDialog){
            $scope.form = form;
            if(!parameters.home){
              $scope.titleUI = parameters.titleUI;
              $scope.descriptionUI = parameters.descriptionUI;
            }
            $scope.closeModal = function(){
              ShortcutsService.enableBackSpaceDefault();
              $mdDialog.hide();
              if(!parameters.home) {
                reloadEmployer();
              }
            };
          }
        ],
        templateUrl: 'app/views/employer/modals/' + parameters.template + '.html'
      });
    };
  }
]);
